export default {
  // 启动页面
  start: {
    use: '开始使用',
    slogan: '所见即所得，一触即达',
    tip: '点击"开始使用"按钮，开启您的智能体验！',
    connectHint: '请插入连接器并将设备置于配对模式以连接。',
    noConnector: '未检测到连接器，请插入后重试。',
    connectorFound: '已找到连接器，请打开设备完成配对。',
    waitingDevice: '等待设备连接...',
    loadingHome: '正在加载主页...',
    deviceConnected: '设备已连接。',
    connecting: '连接中...',
    waitingPairing: '等待配对中',
    pairingHint: '请打开您的耳机电源，等待配对',
    waitingUSB: '等待USB连接',
    usbHint: '请确保USB线缆已正确连接',
    retry: '重试',
    errorDefault: '连接失败，请重试',
    deviceNotFound: '未找到设备，请检查连接',
    permissionDenied: '设备权限被拒绝',
  },

  // 耳返
  sidetone: {
    label: '耳返',
    volume: '音量',
    enabled: '已开启',
    disabled: '已关闭',
  },

  // 音频混合
  audio: {
    mix: '混音模式',
    split: '分离模式',
    adaptive: '自适应',
    balance: '音频平衡',
    dongle: 'Dongle',
    bluetooth: '蓝牙',
    usb: 'USB',
  },

  // 通话桥接
  callBridge: {
    label: '通话桥接',
    enabled: '已开启',
    disabled: '已关闭',
    consentTitle: '通话桥接功能说明',
    consentMessage: '通话桥接功能允许您在游戏和通话之间无缝切换。开启前请阅读以下说明：',
    point1: '该功能会混合游戏音频和通话音频',
    point2: '可能会影响游戏音质体验',
    point3: '建议在需要时临时开启',
    noticeTitle: '重要提示',
    noticeContent: '首次使用需要配置音频设备权限，请按照系统提示操作。',
    agree: '我已了解并同意开启',
  },

  // 蓝牙分享
  btShare: {
    label: '蓝牙分享',
    enabled: '已开启',
    disabled: '已关闭',
    consentTitle: '蓝牙音频分享',
    consentMessage: '蓝牙音频分享功能可以让多个设备同时收听。请注意：',
    point1: '将音频分享至附近的蓝牙设备',
    point2: '可能会略微增加音频延迟',
    point3: '需要保持蓝牙连接处于激活状态',
    noticeTitle: '使用提示',
    noticeContent: '请确保接收设备已开启蓝牙并处于配对模式。',
    agree: '知道了，开启',
  },

  // 固件升级
  upgrade: {
    title: '固件升级',
    currentVersion: '当前版本',
    dongleTab: 'Dongle',
    headsetTab: '耳机',
    bluetoothTab: '蓝牙',
    dongleUpgrade: 'Dongle固件升级',
    headsetUpgrade: '耳机固件升级',
    bluetoothUpgrade: '蓝牙固件升级',
    dongleDesc: '升级Dongle固件以获得更好的连接稳定性',
    headsetDesc: '升级耳机固件以获得更好的音质和功能',
    bluetoothDesc: '升级蓝牙模块固件',
    step1: '选择固件文件',
    step2: '验证文件',
    step3: '上传升级',
    step4: '完成',
    selectFile: '请选择固件文件（.bin, .hex, .fw）',
    verifyFile: '验证固件文件信息',
    upgrading: '正在升级，请勿断开连接...',
    waiting: '等待完成',
    success: '升级成功！',
    startUpgrade: '开始升级',
    complete: '完成',
    uploading: '上传中',
    verifying: '验证中',
    warning: '⚠️ 重要提示',
    warningPoint1: '升级过程中请勿断开设备连接',
    warningPoint2: '升级过程可能需要3-5分钟，请耐心等待',
    warningPoint3: '升级失败可能导致设备无法使用，请谨慎操作',
    headsetNotice: '耳机升级功能即将推出，敬请期待',
    bluetoothNotice: '蓝牙升级功能即将推出，敬请期待',
  },
  // 通用
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    close: '关闭',
    loading: '加载中...',
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示',
    loginSaveWarning: '您尚未登录，本页面的操作将无法保存',
    goToLogin: '去登录',
  },

  // 导航
  nav: {
    home: '首页',
    eq: 'EQ设置',
    rgb: 'RGB灯光',
    noise: '通话降噪',
    voice: '魔幻音效',
    chiji: '一键吃鸡',
    ai: 'AI小助手',
    upgrade: '固件升级',
    user: '用户中心',
    settings: '设置',
    logout: '退出登录',
  },

  // RGB
  rgb: {
    title: 'RGB灯光设置',
    on: '开启',
    off: '关闭',
    selectMode: '选择灯效模式',
    brightness: '亮度调节',
    connectDevice: '请先连接设备以控制RGB灯光',
    modes: {
      breathing: '灵动呼吸',
      gradient: '流光渐变',
      chase: '炫彩环跑',
      red: '单色红',
      blue: '单色蓝',
      green: '单色绿',
      purple: '单色紫',
      yellow: '单色黄',
      cyan: '单色青',
      white: '单色白',
    },
  },

  // 首页
  home: {
    start: '开始使用',
    connectDevice: '连接设备',
    deviceNotFound: '未检测到设备，请插入后重试',
    welcome: '欢迎使用飞籁云驱',
  },

  // 设备
  device: {
    connected: '已连接',
    disconnected: '未连接',
    connecting: '连接中...',
    battery: '电量',
    batteryLow: '电量不足',
    charging: '充电中',
    headphone: '耳机',
    microphone: '麦克风',
    usbMode: 'USB有线模式',
    wirelessMode: '2.4G无线模式',
    unknown: '未知设备',
    bluetooth: '蓝牙版本',
  },

  // EQ
  eq: {
    title: 'EQ设置',
    game: '游戏模式',
    music: '音乐模式',
    movie: '电影模式',
    gameShort: '游戏',
    musicShort: '音乐',
    movieShort: '电影',
    enabled: '开启EQ',
    disabled: '关闭EQ',
    custom: '自定义',
    addCustom: '添加自定义',
    deleteConfirm: '确定要删除这个预设吗？',
    deleteConfirmTitle: '确定要删除这个标签吗？',
    deleteConfirmDescription: '此操作无法撤销。',
    reset: '重置',
    pin: '置顶',
    saveAs: '另存为',
    copy: '副本',
    saved: '预设已保存',
    pinned: '预设已置顶',
    resetDone: '预设已重置',
    customLimit: '最多可保存20个自定义预设',
    customLimitLight: '最多可保存20个自定义标签。',
    nameLengthLimit: '标签名称最多20个字符。',
    nameExists: '该预设名称已存在',
    rename: '重命名预设',
    gain: '增益',
    frequency: '频率',
  },

  // 降噪
  noise: {
    title: '通话降噪',
    aiNoise: 'AI降噪',
    aiNoiseHeadphone: 'AI降噪',
    micNoise: '麦克风降噪',
    level: '降噪等级',
    levelLow: '低',
    levelMedium: '中',
    levelHigh: '高',
    enc: 'AI ENC降噪',
    encDesc: '智能识别环境噪音，提升通话清晰度',
    aiNoiseDesc: '建议在通话或录音时开启，可有效降低环境噪音',
  },

  // 变声效果
  voice: {
    title: '魔幻音效',
    enabled: '开启变声',
    boy: '男声',
    girl: '女声',
    child: '儿童',
    robot: '机器人',
    monster: '怪物',
    normal: '原声',
    preview: '效果预览',
    previewHint: '开启后可以实时预览变声效果',
  },

  // 固件
  firmware: {
    title: '固件升级',
    currentVersion: '当前版本',
    latestVersion: '最新版本',
    checkUpdate: '检查更新',
    startUpgrade: '开始升级',
    selectTarget: '选择升级目标',
    updating: '升级中...',
    updateSuccess: '升级成功',
    updateFailed: '升级失败',
    releaseNotes: '更新日志',
    deviceReady: '设备就绪',
    deviceLowPower: '电量过低',
    deviceBusy: '设备忙碌',
    historyVersions: '历史版本',
    selectLocalFile: '选择本地固件',
    manualPick: '手动选择设备',
    version: '版本号',
    updateDate: '更新时间',
    management: '固件管理',
    device: '型号',
    fileName: '文件名',
    description: '描述',
    action: '操作',
    upgradeToLatest: '升级到最新版本',
    rollbackTip: '如需版本回退，',
    historyView: '查看',
    historyHide: '隐藏',
    upgradeToThisVersion: '升级到该版本',
    confirmUpgradeTitle: '确定要升级到 {version} 版本吗？',
    confirmUpgradeDesc: '确认后升级将运行至完成，期间无法中断。请保持电源和连接稳定。',
    preparingUpgrade: '准备升级...',
    preparing: '准备中...',
    detectingDevice: '正在检测设备...',
    reconnectingDevice: '正在重连设备...',
    downloadingFirmware: '正在下载固件...',
    sendingEnterUpgrade: '正在发送进入升级命令...',
    waitingUpgradeDevice: '命令已发送，正在等待升级模式设备...',
    transferringFirmware: '正在传输固件数据...',
    upgradingTitle: '正在升级 [{device}]，请勿断开连接。',
    upgradeCompleteTitle: '升级完成 [{device}]',
    upgradeFailedTitle: '升级失败 [{device}]',
    upgradeComplete: '升级完成！',
    upgradeFailed: '升级失败',
    upgradeWarning: '正在升级。请勿关闭此页面或断开连接。',
    failedChoosePrefix: '升级失败，你可以选择另一个',
    historyVersion: '历史版本',
    deviceNotFoundPlease: '未找到设备，请',
    selectManually: '手动选择',
    noVersions: '暂无版本',
    noDeviceSelected: '未选择设备',
    unknownDevice: '未知设备',
    deviceNotFound: '未找到设备',
    deviceInfo: '设备：{name}（VID:0x{vid} PID:0x{pid}）',
    failedSelectHistory: '升级失败。请选择一个历史版本继续。',
    versionBeforeUpgrade: '升级前版本',
    upgradeSuccessToast: '升级成功，体验已更新！',
    connectionTypeUsb: 'USB有线',
    connectionTypeDongle: '2.4G无线dongle模式',
    connectionTypeUnknown: '未知连接方式',
    connectionTypeMismatch: '当前连接方式不满足【{device}】升级要求，请切换为{required}后再试。',
    connectionTypeMismatchStatus: '当前连接方式为{actual}，而【{device}】升级需要{required}。',
    connectionTypeUnknownStatus: '无法识别当前连接方式，请确认已连接正确设备后再试。',
    descriptions: {
      earphone: {
        latest: '优化音频 EQ，使低频更饱满、高频更清晰。',
        V1_1_2: '优化音频 EQ。',
        V1_1_1: '修复静电噪声问题。',
      },
      earphoneBluetooth: {
        latest: '增强蓝牙连接稳定性。',
        V1_1_3: '增强蓝牙连接稳定性。',
        V1_1_2: '增强蓝牙稳定性。',
        V1_1_1: '增强蓝牙稳定性。',
      },
      earphoneNoiseCancel: {
        latest: '升级风噪降低算法。',
        V1_1_2: '增强降噪效果。',
      },
      dongle: {
        latest: '解决 USB 3.0 兼容性问题。',
        V1_1_2: '修复稳定性问题。',
      },
    },
    tabs: {
      earphone: '耳机',
      earphoneBluetooth: '耳机蓝牙',
      earphoneNoiseCancel: '耳机降噪',
      dongle: 'Dongle',
    },
  },

  // 用户中心
  user: {
    profile: '用户中心',
    profileNav: '个人资料',
    account: '账号',
    passwordNav: '密码',
    upgrade: '升级',
    accountSettings: '账号设置',
    passwordSettings: '密码设置',
    // 个人资料页
    nickname: '昵称',
    inputNickname: '请输入',
    changeAvatar: '更改头像',
    saveChanges: '确认修改',
    avatarEditorCancel: '取消',
    avatarEditorSave: '保存',
    // 账号设置
    linkAccount: '绑定账号',
    linkPhone: '绑定手机号码',
    inputPhone: '请输入',
    phoneNext: '下一步',
    phoneChange: '更换',
    linkEmail: '绑定邮箱',
    inputEmail: '请输入',
    emailNext: '下一步',
    emailChange: '更换',
    linkThirdParty: '绑定第三方账号',
    linkThirdPartyDesc: '绑定第三方账号，轻松登录飞籁云驱，还能把您的内容同步到以下平台，分享给更多好友。',
    googleLink: '绑定',
    wechatLink: '绑定',
    verificationCode: '验证码',
    inputVerCode: '请输入验证码',
    getCode: '获取验证码',
    sendCode: '发送验证码',
    resend: '{sec}s',
    verifyNext: '下一步',
    phoneConfirm: '确认绑定手机号',
    emailConfirm: '确认绑定',
    deleteAccount: '注销账号',
    deleteAccountDesc: '注销后账号所有数据将被销毁并不可找回，请谨慎操作。',
    deleteAccountBtn: '注销账号',
    deleteDialogTitle: '确定要注销账号吗？',
    deleteDialogDesc: '注销后所有数据将被永久删除且无法恢复。',
    deleteDialogCancel: '取消',
    deleteDialogConfirm: '确认注销',
    // 密码设置
    pwdAccount: '账号',
    pwdEnterAccount: '请输入手机号或者邮箱号码',
    pwdNext: '下一步',
    pwdVerifyCode: '验证码',
    pwdInputVerCode: '请输入验证码',
    pwdGetCode: '获取验证码',
    pwdSendCode: '发送验证码',
    pwdVerifyNext: '下一步',
    pwdNewPassword: '新密码',
    pwdInputNew: '请输入',
    pwdConfirmPassword: '确认新密码',
    pwdInputConfirm: '请输入',
    pwdConfirmBtn: '确认修改',
    pwdThirdPartyWarning: '当前为第三方帐号授权登录，需要通过账号设置密码里绑定手机号/邮箱号登录才可以设置密码。',
    // 提示
    tipUsernameEmpty: '昵称不能为空！',
    tipUsernameSuccess: '昵称修改成功！',
    tipAvatarSuccess: '头像更新成功！',
    tipAvatarFail: '头像处理失败',
    tipSelectImage: '请选择一个图片文件！',
    tipEnterPhone: '请输入手机号',
    tipInvalidPhone: '请输入正确的手机号',
    tipEnterEmail: '请输入邮箱',
    tipInvalidEmail: '请输入正确的邮箱',
    tipEnterCode: '请输入6位验证码',
    tipCodeSent: '验证码发送成功',
    tipPhoneBound: '手机号绑定成功',
    tipEmailBound: '邮箱绑定成功',
    tipBindFailed: '绑定失败，请稍后再试',
    tipOnlyAuth: '当前账号是唯一认证方式，无法更换',
    tipVerifyPassed: '验证通过，请绑定新账号',
    tipGoogleBound: 'Google 账号绑定成功',
    tipWechatBound: '微信账号绑定成功',
    tipAllowPopup: '请允许弹窗以完成绑定',
    tipDeleteSuccess: '账号注销成功',
    tipEnterPhoneEmail: '请输入手机号或邮箱',
    tipInvalidPhoneEmail: '请输入正确的手机号或邮箱',
    tipAccountNotLinked: '该账号暂未绑定，只能修改当前登录账号的密码',
    tipPwdFormat: '密码需8~16位，包含字母和数字',
    tipPwdMismatch: '两次输入的密码不一致',
    tipPwdSuccess: '密码修改成功',
    tipCodeSentSuccess: '验证码已发送',
    tipEnter6Code: '请输入6位验证码',
    // 其他
    email: '邮箱',
    phone: '手机',
    avatar: '头像',
    password: '密码',
    changePassword: '修改密码',
    saveSuccess: '保存成功',
  },

  // 认证
  auth: {
    login: '登录',
    register: '注册',
    forgotPassword: '忘记密码',
    email: '邮箱',
    phone: '手机号',
    password: '密码',
    confirmPassword: '确认密码',
    verificationCode: '验证码',
    getCode: '获取验证码',
    loginSuccess: '登录成功',
    registerSuccess: '注册成功',
    passwordMismatch: '两次密码不一致',
    username: '用户名',
    rememberMe: '记住我',
    noAccount: '还没有账号？',
    registerNow: '立即注册',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    agreeTerms: '我已阅读并同意',
    termsOfService: '服务条款',
    and: '和',
    privacyPolicy: '隐私政策',
    authType: '认证方式',
    // 登录页
    headerTitle: '欢迎登录您的账号',
    googleLogin: '谷歌登录',
    wechatLogin: '微信登录',
    middleTitle: '手机/邮箱登录',
    phoneOrEmail: '手机号/邮箱',
    inputPhoneOrEmail: '请输入手机号或邮箱',
    inputPassword: '请输入密码',
    passwordLoginBtn: '密码登录',
    codeLoginBtn: '验证码登录',
    passwordTips: '请确认已设置过密码',
    sendCodeBtn: '获取验证码',
    loginBtn: '登录',
    securityText: '登录即注册，代表你同意该网站的',
    userAgreement: '用户协议',
    privacyAgreement: '隐私协议',
    // 验证页
    checkPhone: '查看手机短信',
    checkEmail: '查看收件箱',
    verifyInstruction: '请输入我们发送至',
    verifySuffix: '的6位验证码',
    verifyBtn: '验证',
    resendCode: '重新发送验证码',
    resendCodeCountdown: '{sec} s 重新发送验证码',
    // 提示
    tipEnterAccount: '请输入手机号或邮箱',
    tipInvalidAccount: '请输入正确的手机号或邮箱',
    tipPasswordFormat: '密码需8~16位，包含字母和数字',
    tipWaitResend: '请等待 {sec} 秒后再获取验证码',
    tipCodeFailed: '获取验证码失败',
    tipEnterCode: '请输入6位验证码',
    tipVerifyFailed: '验证码错误',
    tipLoginFailed: '登录失败',
    tipResendFailed: '发送失败',
    tipThirdPartyFailed: '获取登录地址失败',
    loading: '请稍候...',
    verifying: '验证中...',
  },

  // 一键吃鸡（游戏模式）
  chiji: {
    title: '一键吃鸡',
    footsteps: '脚步声',
    gunfire: '枪声',
    enabled: '开启游戏模式',
    presets: '预设',
    addPreset: '添加预设',
    deletePreset: '删除预设',
    deleteConfirm: '确定要删除预设 "{name}" 吗？',
    presetNamePlaceholder: '请输入预设名称',
    gunSound: '枪声增强',
    footstep: '脚步声增强',
    gunHint: '增强枪声的低频表现，提升射击反馈',
    footstepHint: '增强脚步声的高频表现，提升定位能力',
    reset: '重置',
    description: '游戏模式通过EQ调节增强枪声和脚步声，提升游戏体验。低频段(20-1000Hz)优化枪声，高频段(2000-16000Hz)优化脚步声。',
  },

  // AI 助手
  aiAssistant: {
    title: 'AI小助手',
    enabled: '启用语音控制',
    disabled: '语音控制已关闭',
    tapToSpeak: '点击麦克风开始语音控制',
    listening: '正在聆听...',
    quickCommands: '快捷指令',
    showHistory: '查看历史',
    hideHistory: '隐藏历史',
    noHistory: '暂无语音记录',
    clearHistory: '清空历史',
    categoryEq: 'EQ模式',
    categoryChiji: '一键吃鸡',
    categoryVoice: '音效',
    categoryDevice: '设备',
    categorySystem: '系统',
    helpTitle: '使用提示：',
    help1: '点击麦克风按钮，说出指令',
    help2: '支持语音："切换游戏模式"、"开启吃鸡"、"静音"等',
    help3: '也可以点击下方快捷指令直接执行',
    browserWarning: '您的浏览器不支持语音识别，请使用 Chrome 或 Edge 浏览器',
    commandSuccess: '指令执行成功',
    commandFailed: '指令执行失败',
  },

  // 顶部栏
  header: {
    battery: '电量',
    usbMode: 'USB',
    wirelessMode: '2.4G',
    language: '语言',
    hotkey: '热键设置',
    theme: {
      dark: '深色',
      light: '浅色',
      system: '系统',
    },
    userCenter: '用户中心',
    firmwareUpgrade: '升级',
    preferences: '偏好设置',
    about: '关于我们',
    aboutUs: '关于我们',
  },

  hotkey: {
    dialogTitle: '热键设置',
    notSet: '未设置',
    conflict: '快捷键冲突：已被',
    conflictUsed: '使用',
    switched: '已切换',
    powerToggle: '开关机',
    eqToggle: 'EQ设置',
    rgbToggle: '灯光',
    aiToggle: 'AI降噪',
    balenceToggle: '音效平衡',
    Positioning: '一键吃鸡',
    tip: '点击输入框后直接按快捷键',
    reset: '恢复默认',
    occupied: '热键已被占用',
  },

  // 底部栏
  footer: {
    eq: 'EQ',
    rgb: 'RGB',
    voice: '音效',
    mute: '静音',
    micMute: '麦克风静音',
    kangganrao: '抗干扰',
    chiji: '一键吃鸡',
    ai: 'AI助手',
    on: '开机',
    off: '关闭',
    noiseLevel: '档',
    gameMode: '游戏模式',
    breathing: '灵动呼吸',
    level: '档',
    audioMix: '音频混合',
    audioSplit: '音频分离',
  },

  // 主菜单（底部菜单）
  main: {
    chickenDinner: '一键吃鸡',
  },

  // 主菜单 RGB（底部菜单 RGB 模式）
  mainrgb: {
    breathing: '紫色律动',
    gradient: '青色律动',
    marquee: '蓝色律动',
    mic_gradient: '幻彩渐变',
    mic_breathing: '幻彩呼吸',
    red: '单色红',
    blue: '单色蓝',
    green: '单色绿',
    purple: '单色紫',
    yellow: '单色黄',
    cyan: '单色青',
    white: '单色白',
  },
} as const
